// Events transverses du plan de marquage Welyft v1 : partagés par les parcours AE et Mutuelle Santé,
// d'où l'absence de préfixe de parcours dans leur nom.
export const CallbackTrackingEvents = {
    accessRequest: 'access_callback_request',
    requestValidated: 'request_callback',
} as const

// Modale « rendez-vous déjà pris » du parcours AE (RDV-2)
export const ExistingCallbackTrackingEvents = {
    modalView: 'rdv_existing_modal_view',
    modify: 'rdv_existing_modify',
    cancel: 'rdv_existing_cancel',
    continue: 'rdv_existing_continue',
} as const

// Le plan impose _valid/_invalid ; le parcours voyage émet encore voyage_phone_validation_true/false.
export const PhoneValidationTrackingEvents = {
    valid: 'health_form_phone_validation_valid',
    invalid: 'health_form_phone_validation_invalid',
} as const

// Single phone + email opt-in of the AE/MS contact-details step; `product` is loan|health.
export const ContactConsentTrackingEvents = {
    checkboxToggle: 'consent_checkbox_toggle',
    errorShown: 'consent_error_shown',
} as const
